import { API_ROUTES } from "../../utils/constants";
import _axios from "./index"; // Import the simplified _axios module

export default class AuthService {

  Get_Jobseeker = async () => {
    try {
      const response = await _axios.get(API_ROUTES.JOBSEEKER.GET_JOBSEEKER);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Update_Jobseeker = async (body) => {
    try {
      const response = await _axios.patch(API_ROUTES.JOBSEEKER.UPDATE_USER, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Jobseeker_Skills = async () => {
    try {
      const response = await _axios.get(API_ROUTES.JOBSEEKER.GET_JOBSEEKER_SKILLS);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Upload_CV = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.JOBSEEKER.UPLOAD_CV, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Remove_CV = async (body) => {
    try {
      const response = await _axios.delete(API_ROUTES.JOBSEEKER.REMOVE_CV, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  // Get_Jobseeker_Jobs = async (searchParams) => {
  //   try {
  //     const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_JOBS}?${searchParams}`);
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  Get_Jobseeker_Jobs = async (searchParams) => {
    try {
      // Convert object to query string
      const queryString = new URLSearchParams(searchParams).toString();
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_JOBS}?${queryString}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

   Get_Jobseeker_Sorted_Jobs = async (searchParams) => {
    try {
      // Convert object to query string
      const queryString = new URLSearchParams(searchParams).toString();
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.SEARCH_JOBS_JOBSEEKER}?${queryString}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Apply_Jobs = async (body) => {
    try {
      const response = await _axios.post(`${API_ROUTES.JOBSEEKER.APPLY_JOB}/${body.jobId}`, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Save_Jobs = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.JOBSEEKER.SAVE_JOBS, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_save_Jobs = async (userId, searchParams) => {
    try {
      const url = `${API_ROUTES.JOBSEEKER.GET_SAVE_JOBS}?jobSeekerId=${userId}${searchParams ? `&${searchParams}` : ""}`;
      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };


  Get_reffered_Jobs = async (userId, searchParams) => {
    try {
      // Construct the URL with proper query parameter concatenation
      const url = `${API_ROUTES.JOBSEEKER.GET_REFFRED_JOBS}?jobSeekerId=${userId}${searchParams ? `&${searchParams}` : ""}`;
      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };


  Send_reffer_Job = async (body) => {
    try {
      const response = await _axios.post(`${API_ROUTES.JOBSEEKER.SEND_REFERE_JOB}`, body);
      return response;
    } catch (err) {
      throw err;
    }
  };
  Get_recommended_Jobs = async (searchParams) => {
    try {
      // Check if searchParams exists and construct the URL accordingly
      const url = searchParams
        ? `${API_ROUTES.JOBSEEKER.GET_RECOMMENDED_JOBS}?${searchParams}` // Only append searchParams if they exist
        : `${API_ROUTES.JOBSEEKER.GET_RECOMMENDED_JOBS}`; // If searchParams doesn't exist, just use the base URL

      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };


  unsave_Jobs = async (body) => {
    try {
      const response = await _axios.delete(API_ROUTES.JOBSEEKER.UNSAVE_JOB, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_profile_percentage = async () => {
    try {
      const response = await _axios.get(API_ROUTES.JOBSEEKER.GET_PROFILE_COMPLETEION_PERCENTAGE);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_interview_dates = async (userId) => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_INTERVIEW_DATES}/${userId}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  send_interview_link = async (body) => {
    try {
      const response = await _axios.post(`${API_ROUTES.JOBSEEKER.SEND_INTERVIEW_DATES}`, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_applied_jobs = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.APPLIED_JOBS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_countries = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_COUNTRIES}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Education_data = async () => {
    try {
      const url = `${API_ROUTES.JOBSEEKER.EDUCATION}`;
      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Experiance_data = async () => {
    try {
      const url = `${API_ROUTES.JOBSEEKER.EXPERIANCES}`;
      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Tickets_data = async () => {
    try {
      const url = `${API_ROUTES.JOBSEEKER.GET_TICKET_LIST}`;
      const response = await _axios.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Create_jobseeker_tickets = async (body) => {
    try {
      const response = await _axios.post(`${API_ROUTES.JOBSEEKER.CREATE_TICKET}`, body);
      return response;
    } catch (err) {
      throw err;
    }
  };


  Get_all_subscriptions = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_ALL_SUBSCRIPTIONS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_latest_subscriptions = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.GET_LATEST_SUBSCRIPTION}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

   Get_ReferrsBy_Jobs = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.REFFERED_BY_JOBS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

   Get_ReffersTo_Jobs = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.JOBSEEKER.REFFERED_TO_JOBS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };
}